import React, { useState } from "react";

const EnableDisableSwitch = ({ enabled, handleStatusToggle }) => {
  return (
    <div
      className={`w-9 h-5 flex items-center rounded-full p-1 cursor-pointer transition-colors
        ${enabled ? "bg-[#de2b26] " : "bg-[#de2b26]/50"}`}
      onClick={() => handleStatusToggle(!enabled)}
    >
      {/* Switch Circle */}
      <div
        className={`bg-white w-3 h-3 rounded-full shadow-md transform transition-transform
          ${enabled ? "translate-x-4" : "translate-x-0"}`}
      ></div>
    </div>
  );
};

export default EnableDisableSwitch;
